(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var page = doc.querySelector('.pd-page');
  if (!page) return;

  /* GERMAN PATH (13 Oct 2026). On the products that carry German copy
     (.pd-page[data-de]) and for a visitor flagged German in <head> (German ad,
     German browser, or the session flag), every string this script writes is
     German too. Everyone else gets exactly the English this always wrote. */
  var DE = root.hasAttribute('data-sr-de') && page.hasAttribute('data-de');
  var COL_DE = { 'Ivory': 'Elfenbein', 'Burgundy': 'Burgund', 'Red': 'Rot', 'Brown': 'Braun',
                 'Olive Green': 'Olivgrün', 'Black': 'Schwarz', 'Pink': 'Rosa', 'White': 'Weiß' };
  function T(en, de) { return DE ? de : en; }
  function colName(c) { return (DE && c && COL_DE[c]) ? COL_DE[c] : c; }
  /* A figure as German writes it: 152,5 rather than 152.5. */
  function nz(v) { return DE ? String(v).replace('.', ',') : String(v); }
  var DATA = {};
  try { DATA = JSON.parse(doc.getElementById('pd-data').textContent); } catch (e) { DATA = {}; }
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduced ? 'auto' : 'smooth';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* --- Gallery ------------------------------------------------------------
     The strip already scrolls and snaps on its own. This keeps the counter,
     the live region and the current thumbnail in step with it, and turns the
     thumbnail anchors into a silent scroll so the page never jumps.

     WHAT IS NEW HERE IS THAT THE SET OF SLIDES IS NOT FIXED. Choosing a
     colour hides the frames that belong to another colourway, so every count,
     every label and every index below is computed against the slides that are
     actually on screen — never against the DOM order. */
  var stage    = doc.getElementById('pd-stage');
  var allSlides = stage ? Array.prototype.slice.call(stage.querySelectorAll('.pd-slide')) : [];
  var allThumbs = Array.prototype.slice.call(doc.querySelectorAll('.pd-thumbs > li'));
  var allDots   = Array.prototype.slice.call(doc.querySelectorAll('.pd-dot'));
  var countEl  = doc.getElementById('pd-count');
  var liveEl   = doc.getElementById('pd-live');
  var slides = allSlides.slice();
  var index = 0;

  function markCurrent(list, i) {
    list.forEach(function (el, n) {
      var a = el.tagName === 'LI' ? el.querySelector('a') : el;
      if (!a) return;
      if (n === i) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  /* The thumbnails and dots in the order now on screen (13 Oct 2026: the
     gallery re-orders by colour instead of hiding the other colourways). */
  var thumbsNow = allThumbs.slice(), dotsNow = allDots.slice();
  function visible(list) {
    if (list === allThumbs) return thumbsNow;
    if (list === allDots) return dotsNow;
    return list.filter(function (el) { return !el.hidden; });
  }

  /* THE DOT RAIL IS A SCROLLER NOW, not a row that pushes the page sideways:
     42 photographs made 1932px of dots inside a 375px viewport and the whole
     product page scrolled horizontally. It scrolls itself instead, and the
     current dot is kept inside its own edges — a scroller whose marker has
     drifted off-screen is a counter that has stopped counting. Only this
     element's scrollLeft is ever touched. */
  var dotsWrap = doc.querySelector('.pd-dots');
  function keepDotInView(i) {
    if (!dotsWrap) return;
    var d = visible(allDots)[i];
    if (!d) return;
    var wr = dotsWrap.getBoundingClientRect(), dr = d.getBoundingClientRect();
    if (dr.left < wr.left) dotsWrap.scrollLeft -= (wr.left - dr.left) + 8;
    else if (dr.right > wr.right) dotsWrap.scrollLeft += (dr.right - wr.right) + 8;
  }

  function paint(i) {
    index = i;
    markCurrent(visible(allThumbs), i);
    markCurrent(visible(allDots), i);
    keepDotInView(i);
    if (countEl) countEl.textContent = pad(i + 1) + ' / ' + pad(slides.length);
    if (liveEl)  liveEl.textContent  = T('Photograph ' + (i + 1) + ' of ' + slides.length, 'Foto ' + (i + 1) + ' von ' + slides.length);
    if (lb && lb.classList.contains('is-open')) showInBox(i);
  }

  function goTo(i) {
    if (!stage || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    stage.scrollTo({ left: stage.clientWidth * i, behavior: behavior });
    paint(i);
  }

  /* THE COLOURWAY FILTER.
     A slide is shown when it carries no colourway of its own (its alt text
     did not name one, so it belongs to all of them) or when it carries this
     one. If that would leave the gallery empty — which cannot happen when the
     server decided the grouping was safe, but is exactly the case worth being
     paranoid about — every frame comes back, because a colour with no
     photographs is worse than a colour with the wrong ones. */
  /* THE COLOURWAY ORDER (13 Oct 2026). Nothing is hidden any more: the
     chosen colourway's photographs move to the front, in the shop's own
     order, and every other colourway's follow, each labelled with its colour
     on the photograph. Hiding them left the red and the olive dress with one
     photograph each. Slides, thumbnails and dots move together, so index n
     means the same photograph in all three. */
  function filterGallery(colour) {
    if (!stage || !allSlides.length) return;
    var mine = [], rest = [];
    allSlides.forEach(function (s, n) {
      var c = s.getAttribute('data-c') || '';
      ((!c || !colour || c === colour) ? mine : rest).push(n);
    });
    var order = mine.concat(rest);
    order.forEach(function (n) {
      var s = allSlides[n];
      s.hidden = false;
      s.parentNode.appendChild(s);
      var c = s.getAttribute('data-c') || '';
      var cap = s.querySelector('.pd-slide__col');
      if (c && colour && c !== colour) {
        if (!cap) { cap = doc.createElement('span'); cap.className = 'pd-slide__col'; s.appendChild(cap); }
        cap.textContent = T('Shown in ' + c + ' — same cut', 'Gezeigt in ' + colName(c) + ' – gleicher Schnitt');
      } else if (cap) {
        cap.parentNode.removeChild(cap);
      }
      var t = allThumbs[n]; if (t) { t.hidden = false; t.parentNode.appendChild(t); }
      var d = allDots[n];   if (d) { d.hidden = false; d.parentNode.appendChild(d); }
    });
    slides = order.map(function (n) { return allSlides[n]; });
    thumbsNow = order.map(function (n) { return allThumbs[n]; }).filter(Boolean);
    dotsNow = order.map(function (n) { return allDots[n]; }).filter(Boolean);

    /* The labels name a position in what is on screen, so they are rewritten
       whenever the order changes. */
    dotsNow.forEach(function (d, i) {
      d.setAttribute('aria-label', T('Photograph ' + (i + 1) + ' of ' + slides.length, 'Foto ' + (i + 1) + ' von ' + slides.length));
    });
    thumbsNow.forEach(function (li, i) {
      var a = li.querySelector('a');
      if (a) a.setAttribute('aria-label', T('Show photograph ' + (i + 1) + ' of ' + slides.length, 'Foto ' + (i + 1) + ' von ' + slides.length + ' zeigen'));
    });

    /* The sticky bar shows the colour she chose, not the product's cover. */
    var barImg = doc.querySelector('.pd-stickybar__media img');
    var t0 = thumbsNow[0] && thumbsNow[0].querySelector('img');
    if (barImg && t0 && t0.getAttribute('src')) barImg.setAttribute('src', t0.getAttribute('src'));

    stage.scrollTo({ left: 0, behavior: 'auto' });
    paint(0);
  }

  if (stage && allSlides.length) {
    var ticking = false;
    stage.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = stage.clientWidth;
        if (w) paint(Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / w))));
      });
    }, { passive: true });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
      else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
    });

    /* The jump targets are resolved against what is visible at the moment of
       the tap, not against the index baked into the markup. */
    allThumbs.concat(allDots).forEach(function (el) {
      var a = el.tagName === 'LI' ? el.querySelector('a') : el;
      if (!a) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var list = el.tagName === 'LI' ? visible(allThumbs) : visible(allDots);
        goTo(list.indexOf(el));
      });
    });

    addEventListener('resize', function () {
      stage.scrollTo({ left: stage.clientWidth * index, behavior: 'auto' });
    });
    paint(0);
  }

  /* --- Enlarged photograph ------------------------------------------------ */
  var lb      = doc.getElementById('pd-lightbox');
  var lbFrame = doc.getElementById('pd-lightbox-frame');
  var lbCount = doc.getElementById('pd-lightbox-count');
  var zoomBtn = doc.getElementById('pd-zoomopen');
  var lbMag   = doc.getElementById('pd-lightbox-mag');
  var lbImg = null, lbReturn = null, lbHide = null;

  function setMag(on) {
    if (!lb) return;
    lb.classList.toggle('is-mag', !!on);
    if (lbMag) {
      lbMag.setAttribute('aria-pressed', on ? 'true' : 'false');
      lbMag.setAttribute('aria-label', on ? T('Reduce the photograph', 'Foto verkleinern') : T('Magnify the photograph', 'Foto vergrößern'));
    }
  }

  function showInBox(i) {
    if (!slides[i]) return;
    var src = slides[i].querySelector('img');
    if (!lbImg) {
      lbImg = doc.createElement('img');
      lbImg.setAttribute('decoding', 'async');
      /* Pointer enhancement: magnify about the point pressed. The control
         that carries this for a keyboard is the button in the footer bar. */
      lbImg.addEventListener('click', function (e) {
        var r = lbImg.getBoundingClientRect();
        if (r.width && r.height && !lbFrame.style.getPropertyValue('--pd-crop')) {
          lbFrame.style.setProperty('--pd-org',
            ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%');
        }
        setMag(!lb.classList.contains('is-mag'));
      });
      lbFrame.appendChild(lbImg);
    }
    setMag(false);
    var cs = getComputedStyle(slides[i]);
    lbFrame.style.setProperty('--pd-pos', cs.getPropertyValue('--pd-pos').trim() || '50% 50%');
    lbFrame.classList.remove('is-cropped');
    lbFrame.style.removeProperty('--pd-crop');
    lbFrame.style.removeProperty('--pd-org');
    if (src.getAttribute('srcset')) lbImg.srcset = src.getAttribute('srcset');
    else lbImg.removeAttribute('srcset');
    lbImg.sizes = '100vw';
    lbImg.src = src.getAttribute('src');
    lbImg.alt = src.getAttribute('alt');
    if (lbCount) lbCount.textContent = pad(i + 1) + ' / ' + pad(slides.length);
  }

  function openBox() {
    if (!lb || lb.classList.contains('is-open')) return;
    lbReturn = doc.activeElement;
    showInBox(index);
    if (lbHide) { clearTimeout(lbHide); lbHide = null; }
    lb.hidden = false;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', T('Enlarged photograph', 'Vergrößertes Foto'));
    lock(true);
    requestAnimationFrame(function () {
      lb.classList.add('is-open');
      doc.getElementById('pd-lightbox-close').focus({ preventScroll: true });
    });
  }

  function closeBox() {
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open', 'is-mag');
    if (lbReturn && lbReturn.focus) lbReturn.focus({ preventScroll: true });
    lbReturn = null;
    lock(false);
    if (lbHide) clearTimeout(lbHide);
    lbHide = setTimeout(function () {
      if (!lb.classList.contains('is-open')) lb.hidden = true;
    }, reduced ? 0 : 420);
  }

  if (lb && allSlides.length) {
    if (zoomBtn) { zoomBtn.hidden = false; zoomBtn.addEventListener('click', openBox); }
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      allSlides.forEach(function (s) {
        s.style.cursor = 'zoom-in';
        s.addEventListener('click', function () { paint(slides.indexOf(s)); openBox(); });
      });
    }
    if (lbMag) {
      lbMag.addEventListener('click', function () {
        if (lbImg) lbImg.style.transformOrigin = '50% 50%';
        setMag(!lb.classList.contains('is-mag'));
      });
    }
    doc.getElementById('pd-lightbox-close').addEventListener('click', closeBox);
    doc.getElementById('pd-lightbox-prev').addEventListener('click', function () { goTo(index - 1); });
    doc.getElementById('pd-lightbox-next').addEventListener('click', function () { goTo(index + 1); });
    doc.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeBox(); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); return; }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(index - 1); return; }
      if (e.key === 'Tab') trap(e, lb);
    });
  }

  /* --- Shared helpers: scroll lock and focus trap ------------------------- */
  function lock(on) {
    var sbw = innerWidth - root.clientWidth;
    root.style.setProperty('--sr-sbw', on && sbw > 0 ? sbw + 'px' : '0px');
    root.classList.toggle('sr-lock', on);
  }
  /* Re-enters from wherever focus actually is, and only ever counts controls
     that are rendered. */
  function trap(e, box) {
    var f = Array.prototype.filter.call(box.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
    if (!f.length) { e.preventDefault(); box.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = doc.activeElement;
    if (!box.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && (a === first || a === box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }

  /* ======================================================================
     THE VARIANT — one field posts, and it is a real Shopify variant id.

     The radio rows are a control on the <select name="id">, not a copy of it.
     Every state on this page — the price, the stock line, the sticky bar, the
     express checkout, the length answer — is read off the resolved variant,
     so none of them can disagree with what the form will post.
     ====================================================================== */
  var VARIANTS = DATA.variants || [];
  var SIZES    = DATA.sizes || [];
  var COLOURS  = DATA.colours || [];
  var SPOS     = DATA.sizePos || 0;
  var CPOS     = DATA.colourPos || 0;
  var EXTRA    = DATA.extraOptions || [];

  var buyForm    = doc.getElementById('pd-buyform');
  var idField    = doc.getElementById('pd-variant');
  var sizeInputs = Array.prototype.slice.call(doc.querySelectorAll('input[name="pd-size"]'));
  var colInputs  = Array.prototype.slice.call(doc.querySelectorAll('input[name="pd-colour"]'));
  var extraInputs= Array.prototype.slice.call(doc.querySelectorAll('input[data-pd-optpos]'));
  var bar        = doc.getElementById('pd-stickybar');
  var addBtn     = doc.getElementById('pd-add');
  var express    = doc.getElementById('pd-express');
  var stockEl    = doc.getElementById('pd-stock');
  var priceEl    = doc.getElementById('pd-price');
  var wasEl      = doc.getElementById('pd-was');
  var saveEl     = doc.getElementById('pd-save');
  var lowestEl   = doc.getElementById('pd-lowest');
  var sizeErr    = doc.getElementById('pd-sizeerr');
  var addedEl    = doc.getElementById('pd-added');

  function chosenSize()   { for (var i = 0; i < sizeInputs.length; i++) if (sizeInputs[i].checked) return sizeInputs[i].value; return null; }
  function chosenColour() { for (var i = 0; i < colInputs.length;  i++) if (colInputs[i].checked)  return colInputs[i].value;  return null; }

  function optOf(v, pos) { return pos === 1 ? v.o1 : pos === 2 ? v.o2 : pos === 3 ? v.o3 : null; }

  /* EVERY OPTION THIS FILE COULD NOT NAME. They are read the same way as size
     and colour and they filter the same search, so a variant can only be
     resolved once she has chosen all of them. */
  function chosenExtras() {
    return EXTRA.map(function (o) {
      var val = null;
      extraInputs.forEach(function (i) {
        if (Number(i.getAttribute('data-pd-optpos')) === o.pos && i.checked) val = i.value;
      });
      return { pos: o.pos, name: o.name, value: val };
    });
  }
  function extrasMatch(v, extras, skipPos) {
    for (var i = 0; i < extras.length; i++) {
      if (extras[i].value === null) continue;
      if (skipPos && extras[i].pos === skipPos) continue;
      if (optOf(v, extras[i].pos) !== extras[i].value) return false;
    }
    return true;
  }
  function extrasComplete(extras) {
    for (var i = 0; i < extras.length; i++) if (extras[i].value === null) return false;
    return true;
  }

  /* PREFER A VARIANT THAT CAN ACTUALLY BE BOUGHT. Returning the first match
     regardless of `available` while sizeAvailable() returned true if ANY match
     was buyable is a dead end waiting for one sale: on the four-style dress,
     Strap sorts first, so the moment Strap/White/XS (qty 3) sells out the XS
     chip stays enabled off Short Sleeve/White/XS, findVariant hands back the
     sold-out Strap, and the button disables itself under "Unavailable in
     white, size XS" for a size that is genuinely in stock. First buyable
     match wins; the first match at all is the fallback, so the sold-out
     message still has a variant to name. */
  function findVariant(size, colour, extras) {
    extras = extras || chosenExtras();
    var fallback = null;
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (SPOS && size !== null && optOf(v, SPOS) !== size) continue;
      if (CPOS && colour !== null && optOf(v, CPOS) !== colour) continue;
      if (!extrasMatch(v, extras)) continue;
      if (v.available) return v;
      if (!fallback) fallback = v;
    }
    return fallback;
  }

  /* A size is offered when it has a buyable variant IN THE CHOSEN COLOUR and
     the chosen everything-else. Not "in some colour" — she is buying one of
     them. */
  function sizeAvailable(size, colour, extras) {
    extras = extras || chosenExtras();
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (SPOS && optOf(v, SPOS) !== size) continue;
      if (CPOS && colour !== null && optOf(v, CPOS) !== colour) continue;
      if (!extrasMatch(v, extras)) continue;
      if (v.available) return true;
    }
    return false;
  }
  function colourAvailable(colour, extras) {
    extras = extras || chosenExtras();
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (CPOS && optOf(v, CPOS) !== colour) continue;
      if (!extrasMatch(v, extras)) continue;
      if (v.available) return true;
    }
    return false;
  }
  /* Judged against the colour and the OTHER unnamed options, never against
     itself — otherwise the value she is standing on disables itself. */
  function extraAvailable(pos, value, colour, extras) {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (optOf(v, pos) !== value) continue;
      if (CPOS && colour !== null && optOf(v, CPOS) !== colour) continue;
      if (!extrasMatch(v, extras, pos)) continue;
      if (v.available) return true;
    }
    return false;
  }

  function syncVariant() {
    var size = chosenSize(), colour = chosenColour();
    var extras = chosenExtras();

    /* The unnamed options are painted FIRST, because size availability is
       judged against them. */
    extraInputs.forEach(function (inp) {
      var pos = Number(inp.getAttribute('data-pd-optpos'));
      var label = inp.closest('.pd-size');
      var ok = extraAvailable(pos, inp.value, colour, extras);
      inp.disabled = !ok;
      if (label) {
        label.classList.toggle('is-out', !ok);
        var sr = label.querySelector('.pd-size__sr');
        if (!ok && !sr) {
          sr = doc.createElement('span');
          sr.className = 'pd-size__sr sr-sr-only';
          sr.textContent = T(', unavailable', ', nicht verfügbar');
          label.appendChild(sr);
        } else if (ok && sr) { sr.remove(); }
      }
      if (!ok && inp.checked) { inp.checked = false; }
    });
    extras = chosenExtras();

    /* VISIBLY AND PROGRAMMATICALLY UNAVAILABLE, NOT SILENTLY ADDABLE. */
    sizeInputs.forEach(function (inp) {
      var label = inp.closest('.pd-size');
      var ok = sizeAvailable(inp.value, colour, extras);
      inp.disabled = !ok;
      if (label) {
        label.classList.toggle('is-out', !ok);
        var sr = label.querySelector('.pd-size__sr');
        if (!ok && !sr) {
          sr = doc.createElement('span');
          sr.className = 'pd-size__sr sr-sr-only';
          sr.textContent = T(', unavailable', ', nicht verfügbar');
          label.appendChild(sr);
        } else if (ok && sr) { sr.remove(); }
      }
      if (!ok && inp.checked) { inp.checked = false; size = null; }
    });
    colInputs.forEach(function (inp) {
      var ok = colourAvailable(inp.value, extras);
      inp.disabled = !ok;
    });

    /* NOTHING RESOLVES UNTIL EVERY OPTION HAS BEEN CHOSEN. An unchosen Style
       used to mean "whichever variant sorted first", which is how a customer
       who read the Slim Fit chart was sold a Strap. */
    var whole = extrasComplete(extras);
    var v = ((SPOS && !size) || !whole) ? null : findVariant(size, colour, extras);
    var sized = (!SPOS || !!size) && whole;

    if (v && idField) idField.value = String(v.id);
    if (v && priceEl) {
      priceEl.innerHTML = '<span class="sr-sr-only">' + T('Price ', 'Preis ') + '</span>' + v.price;
    }
    /* THE SALE FIGURES FOLLOW THE RESOLVED VARIANT, AND ONLY A RESOLVED ONE.
       Until every option is chosen nothing is resolved, and the figures the
       server printed stay as they are. This block used to clear the
       crossed-out price whenever no variant was resolved, which on arrival
       (no size chosen yet) hid every sale from everyone. */
    if (v) {
      if (wasEl) {
        if (v.was) { wasEl.innerHTML = '<span class="sr-sr-only">' + T('Previous price ', 'Vorheriger Preis ') + '</span>' + v.was; wasEl.hidden = false; }
        else { wasEl.textContent = ''; wasEl.hidden = true; }
      }
      if (saveEl) {
        if (v.save) { saveEl.innerHTML = '<span class="sr-sr-only">' + T('You save ', 'Sie sparen ') + '</span>−' + v.save + '%'; saveEl.hidden = false; }
        else { saveEl.hidden = true; }
      }
      if (lowestEl) {
        if (v.was) { lowestEl.textContent = (lowestEl.getAttribute(DE ? 'data-label-de' : 'data-label') || lowestEl.getAttribute('data-label') || '') + ' ' + v.was; lowestEl.hidden = false; }
        else { lowestEl.hidden = true; }
      }
    }

    doc.body.classList.toggle('pd--sized', sized);
    page.classList.toggle('pd--sized', sized);

    /* The legends' visual echo, written here rather than by a stylesheet: on
       this store the values are the product's own and cannot be named in
       CSS. aria-hidden, because the radio groups announce their own
       selection. */
    var cval = doc.querySelector('.pd-opt__value--colour');
    if (cval) cval.textContent = colName(colour) || '';
    var sval = doc.querySelector('.pd-opt__value--size');
    if (sval) sval.textContent = size || '';
    Array.prototype.forEach.call(doc.querySelectorAll('.pd-opt__value--extra'), function (el) {
      var pos = Number(el.getAttribute('data-pd-optpos'));
      var found = '';
      extras.forEach(function (e) { if (e.pos === pos && e.value) found = e.value; });
      el.textContent = found;
    });
    var be = doc.querySelector('.pd-bar__v--extra');
    if (be) {
      be.textContent = extras.length
        ? extras.map(function (e) {
            return e.value || T('no ' + String(e.name || 'option').toLowerCase() + ' chosen', String(e.name || 'Option') + ' nicht gewählt');
          }).join(' · ') + ' · '
        : '';
    }
    var bc = doc.querySelector('.pd-bar__v--colour');
    if (bc) bc.textContent = colName(colour) || '';
    var bs = doc.querySelector('.pd-bar__v--size');
    if (bs) bs.textContent = size ? T(' · size ', ' · Größe ') + size : (SPOS ? T(' · no size chosen', ' · keine Größe gewählt') : '');

    /* Express checkout only once there is a whole variant to express-buy. */
    if (express) express.hidden = !(v && v.available);
    if (addBtn && !addBtn.hasAttribute('data-locked')) {
      addBtn.disabled = !!(v && !v.available);
    }

    /* STOCK. Only "Unavailable" is ever said (11 Oct 2026). The counts in
       this store's inventory are placeholders: every piece is ordered from
       the maker after the customer orders, so "2 left" or "10 left" was an
       invented number. Nothing is said about a size that can be ordered. */
    if (stockEl) {
      var txt = '';
      if (v && sized && !v.available) {
        txt = DE
          ? (colour ? 'In ' + colName(colour) : 'In dieser Ausführung') + (size ? ', Größe ' + size : '') + ' nicht verfügbar.'
          : 'Unavailable' + (colour ? ' in ' + colour.toLowerCase() : '') + (size ? ', size ' + size : '') + '.';
      }
      stockEl.textContent = txt;
    }
  }

  colInputs.forEach(function (inp) {
    inp.addEventListener('change', function () {
      filterGallery(inp.value);
      syncAll();
    });
  });
  sizeInputs.forEach(function (inp) {
    inp.addEventListener('change', function () { if (sizeErr) sizeErr.textContent = ''; syncAll(); });
  });
  extraInputs.forEach(function (inp) {
    inp.addEventListener('change', function () {
      var err = doc.querySelector('[data-pd-opterr="' + inp.getAttribute('data-pd-optpos') + '"]');
      if (err) err.textContent = '';
      syncAll();
    });
  });

  /* The form is the store's own. It posts a real variant id to /cart/add and
     the store's cart takes it from there — there is no second cart in this
     file. All this handler does is refuse to post when no size has been
     chosen, and say which step is missing. */
  if (buyForm) {
    /* With the script on, the radio rows are the control and this select is
       the field they write to: out of the tab ring, out of the accessibility
       tree, still the one thing that posts. */
    buyForm.noValidate = true;
    if (idField) {
      idField.setAttribute('tabindex', '-1');
      var nojs = idField.closest('.pd-nojs');
      if (nojs) nojs.setAttribute('aria-hidden', 'true');
    }
    buyForm.addEventListener('submit', function (e) {
      var pending = chosenExtras().filter(function (o) { return o.value === null; })[0];
      if (pending) {
        e.preventDefault();
        var perr = doc.querySelector('[data-pd-opterr="' + pending.pos + '"]');
        if (perr) perr.textContent = T('Choose ' + String(pending.name || 'an option').toLowerCase() + ' first.', 'Bitte zuerst ' + String(pending.name || 'eine Option') + ' wählen.');
        var fx = extraInputs.filter(function (i) {
          return !i.disabled && Number(i.getAttribute('data-pd-optpos')) === pending.pos;
        })[0];
        if (fx) fx.focus({ preventScroll: false });
        return;
      }
      if (SPOS && !chosenSize()) {
        e.preventDefault();
        if (sizeErr) sizeErr.textContent = T('Choose a size first.', 'Bitte wählen Sie zuerst eine Größe.');
        var first = sizeInputs.filter(function (i) { return !i.disabled; })[0];
        if (first) first.focus({ preventScroll: false });
        return;
      }
      if (addedEl) { addedEl.textContent = T('Adding…', 'Wird hinzugefügt…'); addedEl.classList.add('is-in'); }
    });
  }

  /* The bar appears once the real button has left the top of the screen.
     Deliberately not an IntersectionObserver: that only reports threshold
     crossings, so a flick-scroll that carries the button from below the fold
     to above the viewport in one step never fires. Reading the position on a
     throttled scroll always tells the truth. */
  if (bar && addBtn) {
    bar.hidden = false;
    var barTick = false;
    var syncBar = function () {
      barTick = false;
      var gone  = addBtn.getBoundingClientRect().bottom < 0;
      var atEnd = scrollY >= (root.scrollHeight - innerHeight) - (bar.offsetHeight + 8);
      bar.classList.toggle('is-in', gone && !atEnd);
    };
    var onBarScroll = function () {
      if (barTick) return;
      barTick = true;
      requestAnimationFrame(syncBar);
    };
    addEventListener('scroll', onBarScroll, { passive: true });
    addEventListener('resize', onBarScroll, { passive: true });
    syncBar();
  }

  /* ======================================================================
     LENGTH — driven by the store's own chart

     THE LENGTH ANSWER. The store publishes the garment's own length per size
     in the custom.size_chart metafield. That is the number a floor-length
     dress lives or dies by, and it means this panel can answer the question
     instead of forwarding it. It does arithmetic on two published numbers and
     one number she gives, and it shows its working.

     THE ESTIMATE IS LABELLED. Shoulder-to-floor is what the sum needs. If she
     measures it, the answer is exact and says so. If she gives height instead,
     shoulder height is taken at 0.82 of stature — a population average, true
     of nobody in particular — and every sentence built from it carries the
     word "about" and offers the exact path.

     WHICH ROW IT IS ALLOWED TO READ IS DECIDED ON THE SERVER, on the chart's
     own How to Measure definition rather than on the word "Length". A skirt
     charts its Length from the waistband, and putting a waist measurement
     through a shoulder-height sum printed hem heights that were wrong by
     35cm. Where the definition does not name the shoulder, #pd-guide is not
     rendered at all and DATA.lengths arrives empty, so nothing below runs.

     The garment length is usually a RANGE, so the answer is a range. Both
     ends are carried through rather than averaged away: a hem that might pool
     3cm and might pool 13cm is a different purchase from one that pools 8cm.
     ====================================================================== */
  var SHOULDER_RATIO = 0.82;
  var TOL = (DATA.tolerance || '').trim();

  /* The Length row, per size, parsed out of the chart's own cells. A cell
     that does not hold one or two numbers is dropped rather than guessed at,
     and if nothing survives, the calculator is never shown.

     THE PATTERN HAS NO SIGN IN IT ON PURPOSE. A garment length is never
     negative, and the separator in "145-155" is a hyphen: a /-?\d+/ pattern
     reads the second figure as MINUS 155, which put the shortest cut in the
     whole chart at -155cm and printed "a cut of -156-146cm in M". Measured
     on the live preview before it was caught. */
  var LENGTHS = (function () {
    var out = {}, raw = DATA.lengths || {}, any = false;
    Object.keys(raw).forEach(function (k) {
      var s = String(raw[k] || '').replace(/[–—]/g, '-');
      var m = s.match(/\d+(?:\.\d+)?/g);
      if (!m || !m.length) return;
      var lo = parseFloat(m[0]);
      var hi = m.length > 1 ? parseFloat(m[1]) : lo;
      if (!isFinite(lo) || !isFinite(hi) || lo <= 0) return;
      out[k] = [Math.min(lo, hi), Math.max(lo, hi)];
      any = true;
    });
    return any ? out : null;
  })();

  /* The chart's own size labels are not always the product's option values:
     the store sells "M(US 6)" and charts it as "M". Matched here, once, so
     the marked column, the length answer and the buy form cannot drift. */
  var CHART_SIZES = DATA.chartSizes || [];
  function keyIn(list, size) {
    if (!size || !list) return null;
    var i, s = size.toLowerCase();
    for (i = 0; i < list.length; i++) if (list[i].toLowerCase() === s) return list[i];
    for (i = 0; i < list.length; i++) {
      var c = list[i].toLowerCase();
      if (c && s.indexOf(c) === 0) return list[i];
    }
    for (i = 0; i < list.length; i++) {
      var c2 = list[i].toLowerCase();
      if (c2 && c2.indexOf(s) === 0) return list[i];
    }
    return null;
  }
  function chartKeyFor(size) { return keyIn(CHART_SIZES, size); }

  var askLinks = Array.prototype.slice.call(doc.querySelectorAll('[data-pd-ask]'));
  var guide    = doc.getElementById('pd-guide');
  var guideFact= doc.getElementById('pd-guidefact');
  var askH     = doc.getElementById('pd-ah');
  var askK     = doc.getElementById('pd-ak');
  var askMode  = doc.getElementById('pd-amode');
  var askLab   = doc.getElementById('pd-ahlab');
  var hemEl    = doc.getElementById('pd-hem');
  var hemMsg   = doc.getElementById('pd-hemmsg');
  var hemAll   = doc.getElementById('pd-hemall');
  var hemHow   = doc.getElementById('pd-hemhow');
  var askSend  = doc.getElementById('pd-asksend');
  var MAILTO   = DATA.email || '';
  var GOWN     = DATA.title || '';

  /* The shortest and longest cut in the whole table, read off LENGTHS rather
     than typed: nothing is hard-coded, so if the chart ever changes these
     sentences change with it. */
  var SHORTEST = null, LONGEST = null;
  if (LENGTHS) {
    Object.keys(LENGTHS).forEach(function (k) {
      if (SHORTEST === null || LENGTHS[k][0] < SHORTEST) SHORTEST = LENGTHS[k][0];
      if (LONGEST  === null || LENGTHS[k][1] > LONGEST)  LONGEST  = LENGTHS[k][1];
    });
  }

  /* THE CALCULATOR HIDES ITSELF RATHER THAN COMPUTE FROM NOTHING. */
  if (guide) {
    if (LENGTHS) {
      guide.hidden = false;
      if (guideFact) {
        var span = (SHORTEST === LONGEST) ? (SHORTEST + 'cm')
                 : (SHORTEST + '–' + LONGEST + 'cm');
        var spanDe = (SHORTEST === LONGEST) ? (nz(SHORTEST) + ' cm')
                 : (nz(SHORTEST) + '–' + nz(LONGEST) + ' cm');
        var lead = doc.createTextNode(T('The chart’s Length row runs ' + span + ', depending on size. ',
                                        'Länge laut Maßtabelle: ' + spanDe + ', je nach Größe. '));
        guideFact.insertBefore(lead, guideFact.firstChild);
      }
    } else {
      guide.remove();
    }
  }

  function num(el, lo, hi) {
    if (!el || el.value === '') return null;
    var v = parseFloat(el.value);
    return (isFinite(v) && v >= lo && v <= hi) ? v : null;
  }
  function cm(v) { return (Math.round(v * 10) / 10).toString().replace('.0', ''); }
  /* Display only — no arithmetic above or below this line changes. An estimate
     that has already put a population ratio through a stated height cannot
     support a tenth of a centimetre. The shoulder-to-floor path keeps the
     decimal, because there the input is a measurement rather than a ratio. */
  function hem(v, exact) { return exact ? cm(v) : String(Math.round(v)); }

  function syncHem() {
    if (!hemEl || !hemMsg || !hemAll || !LENGTHS) return;
    var size = chosenSize();
    var key  = chartKeyFor(size);
    var exact = !!(askMode && askMode.checked);
    if (askLab) askLab.textContent = exact ? T('Shoulder to floor', 'Schulter bis Boden') : T('Your height', 'Ihre Körpergröße');
    if (askH)   askH.setAttribute('min', exact ? '90' : '120');

    var given = num(askH, exact ? 90 : 120, 210);
    var heel  = num(askK, 0, 16);
    if (heel === null) heel = 0;

    if (!given) { hemMsg.textContent = ''; hemAll.textContent = ''; hemHow.textContent = ''; return; }
    if (!size || !key || !LENGTHS[key]) {
      hemMsg.textContent = T('Choose a size and we will place the hem.', 'Wählen Sie eine Größe, dann zeigen wir, wo der Saum endet.');
      hemAll.textContent = '';
      hemHow.textContent = '';
      return;
    }

    var shoulder = exact ? given : given * SHOULDER_RATIO;
    var standing = shoulder + heel;
    var L = LENGTHS[key];
    /* clearance = how far the hem sits above the floor. Negative means it is
       on the floor. The longest cut gives the smallest clearance. */
    var loClear = standing - L[1];
    var hiClear = standing - L[0];
    var about = exact ? '' : 'about ';

    var msg;
    var etwa = exact ? '' : 'etwa ';
    function hd(v) { return nz(hem(v, exact)); }
    if (DE) {
      if (loClear >= 0) {
        msg = 'In Größe ' + size + ' endet der Saum ' + etwa
          + ((loClear === hiClear) ? hd(loClear) : (hd(loClear) + '–' + hd(hiClear))) + ' cm über dem Boden.';
      } else if (hiClear <= 0) {
        msg = 'In Größe ' + size + ' liegen ' + etwa
          + ((loClear === hiClear) ? hd(-loClear) : (hd(-hiClear) + '–' + hd(-loClear))) + ' cm Saum auf dem Boden.';
      } else {
        var onFloorDe = hem(-loClear, exact);
        msg = (parseFloat(onFloorDe) === 0)
          ? 'In Größe ' + size + ' berührt der Saum gerade den Boden – beim kürzesten Schnitt ' + etwa + hd(hiClear) + ' cm Abstand.'
          : 'In Größe ' + size + ' endet der Saum zwischen ' + etwa + hd(hiClear) + ' cm über dem Boden und ' + nz(onFloorDe) + ' cm auf dem Boden.';
      }
    } else if (loClear >= 0) {
      msg = (loClear === hiClear)
        ? 'In ' + size + ', the hem should sit ' + about + hem(loClear, exact) + 'cm above the floor.'
        : 'In ' + size + ', the hem should sit ' + about + hem(loClear, exact) + '–' + hem(hiClear, exact) + 'cm above the floor.';
    } else if (hiClear <= 0) {
      msg = (loClear === hiClear)
        ? 'In ' + size + ', expect ' + about + hem(-loClear, exact) + 'cm of hem on the floor.'
        : 'In ' + size + ', expect ' + about + hem(-hiClear, exact) + '–' + hem(-loClear, exact) + 'cm of hem on the floor.';
    } else {
      /* DEGENERATE END, PHRASED AS ENGLISH. At 190cm in M the range is -0.2 to
         +9.8, which rounds to "between about 10cm above the floor and 0cm on
         it" — arithmetically right and unreadable as an answer. When the
         on-floor end rounds away, the sentence says what that actually means
         instead of printing a zero. No figure changes. */
      var onFloor = hem(-loClear, exact);
      msg = (parseFloat(onFloor) === 0)
        ? 'In ' + size + ', the hem should just reach the floor — ' + about
            + hem(hiClear, exact) + 'cm of clearance at the shortest cut.'
        : 'In ' + size + ', the hem should fall between ' + about + hem(hiClear, exact)
            + 'cm above the floor and ' + onFloor + 'cm on it.';
    }
    hemMsg.textContent = msg;

    /* THE SENTENCE AFTER THE ANSWER, WHICH IS THE ONE SHE ACTS ON.
       "3-13cm of hem on the floor in M" is answered by "then I should size
       down" — and the chart on this page already knows the shortest cut it
       makes, so if she is under that, every size pools. Pure arithmetic on
       two published numbers, and it is the difference between buying with
       your eyes open and ordering S, paying the return postage and being
       angry. Not offered when the hem already clears the floor. */
    if (standing < SHORTEST) {
      hemAll.textContent = T('The shortest cut in the chart is ' + SHORTEST + 'cm, so it will sit on the floor in every size.',
        'Der kürzeste Schnitt in der Tabelle ist ' + nz(SHORTEST) + ' cm – das Kleid liegt also in jeder Größe auf dem Boden auf.');
    } else {
      hemAll.textContent = '';
    }

    /* "shoulder taken at 82% of height plus 8cm heels" parses on first read as
       82% of (height + heels), which is not what the two lines above do: the
       ratio is applied to height alone and the heel is added afterwards. Two
       commas, no figure changed. The tolerance is the chart's own sentence,
       in the store's own words, and is omitted where the chart states none. */
    var cut = (L[0] === L[1]) ? (L[0] + 'cm') : (L[0] + '–' + L[1] + 'cm');
    /* German: the same working, in German. The chart's tolerance sentence is
       the shop's own English, so it is left out here rather than mixed in. */
    if (DE) {
      var cutDe = (L[0] === L[1]) ? (nz(L[0]) + ' cm') : (nz(L[0]) + '–' + nz(L[1]) + ' cm');
      hemHow.textContent = (exact
          ? 'Ihre ' + nz(cm(given)) + ' cm'
          : 'Geschätzt: ' + nz(cm(given)) + ' cm Körpergröße, Schulterhöhe mit 82 % der Körpergröße angesetzt')
        + (heel ? ', plus ' + nz(cm(heel)) + ' cm Absatz,' : '')
        + ' gegenüber einer Länge von ' + cutDe + ' in Größe ' + size + '.'
        + (exact ? '' : ' Für ein genaues Ergebnis messen Sie von der Schulter bis zum Boden.');
      return;
    }
    hemHow.textContent = (exact
        ? 'Your ' + cm(given) + 'cm'
        : 'Estimated: ' + cm(given) + 'cm tall, shoulder taken at 82% of height')
      + (heel ? ', plus ' + cm(heel) + 'cm heels,' : '')
      + ' against a cut of ' + cut + ' in ' + size + '.'
      + (TOL ? ' ' + TOL : '')
      + (exact ? '' : ' Measure shoulder to floor for an exact answer.');
  }

  /* --- the enquiry, still there for what arithmetic cannot answer ---------- */
  function askBody(topic) {
    var size = chosenSize(), colour = chosenColour(), exact = !!(askMode && askMode.checked);
    var given = num(askH, exact ? 90 : 120, 210), heel = num(askK, 0, 16);
    if (DE) {
      var G = ['Hallo,', ''];
      G.push(topic === 'fabric'
        ? 'können Sie mir mehr über Material und Pflege von ' + GOWN + ' sagen?'
        : topic === 'delivery'
        ? 'können Sie mir sagen, ob ' + GOWN + ' rechtzeitig bei mir ankommt? Mein Termin ist am:'
        : 'können Sie die Länge von ' + GOWN + ' für mich prüfen?');
      G.push('');
      chosenExtras().forEach(function (o) {
        if (o.value) G.push((o.name || 'Option') + ': ' + o.value);
      });
      if (colour) G.push('Farbe: ' + colName(colour));
      if (size)   G.push('Größe: ' + size);
      if (given)  G.push((exact ? 'Schulter bis Boden: ' : 'Meine Körpergröße: ') + nz(cm(given)) + ' cm');
      if (heel)   G.push('Absatz: ' + nz(cm(heel)) + ' cm');
      G.push(''); G.push('Vielen Dank.');
      return G.join('\n');
    }
    var L = ['Hello,', ''];
    L.push(topic === 'fabric'
      ? 'Please could you tell me more about the fabric and care of the ' + GOWN + '?'
      : topic === 'delivery'
      ? 'Please could you tell me whether the ' + GOWN + ' would reach me in time? My event is on:'
      : 'Please could you check the length of the ' + GOWN + ' for me?');
    L.push('');
    chosenExtras().forEach(function (o) {
      if (o.value) L.push((o.name || 'Option') + ': ' + o.value);
    });
    if (colour) L.push('Colour: ' + colour);
    if (size)   L.push('Size: ' + size);
    if (given)  L.push((exact ? 'My shoulder to floor: ' : 'My height: ') + cm(given) + 'cm');
    if (heel)   L.push('Heels: ' + cm(heel) + 'cm');
    L.push(''); L.push('Thank you.');
    return L.join('\n');
  }
  function mailHref(topic, subject) {
    return 'mailto:' + MAILTO + '?subject=' + encodeURIComponent(subject)
         + '&body=' + encodeURIComponent(askBody(topic));
  }
  function syncAsk() {
    if (!MAILTO) return;
    askLinks.forEach(function (a) {
      /* An explicit data-pd-ask value wins. A delivery question that arrives
         prefilled as a length question is worse than no prefill at all. */
      var t = a.textContent.toLowerCase();
      var topic = a.getAttribute('data-pd-ask')
                || (t.indexOf('fabric') > -1 ? 'fabric'
                :   t.indexOf('delivery') > -1 ? 'delivery' : 'length');
      a.href = mailHref(topic, GOWN + ' — ' + (topic === 'fabric' ? T('fabric and care', 'Material und Pflege')
                                             : topic === 'delivery' ? T('delivery', 'Lieferung') : T('length', 'Länge')));
    });
    if (askSend) askSend.href = mailHref('length', GOWN + ' — ' + T('length', 'Länge'));
  }

  function syncAll() { syncVariant(); syncHem(); syncAsk(); paintChartSize(); paintMsSizes(); }
  [askH, askK, askMode].forEach(function (el) {
    if (el) el.addEventListener(el === askMode ? 'change' : 'input', function () { syncHem(); syncAsk(); });
  });

  /* ======================================================================
     THE MEASUREMENTS DIALOG

     ONE COPY OF THE FIGURES. #pd-mschart is authored inside the accordion and
     MOVED here on load. There is no second table, no cloned markup and no
     numbers in this script — so the cm and inch figures cannot drift apart
     from each other or from the store's metafield.

     THE ACCORDION IS THE FALLBACK, NOT A LEFTOVER. With the script off, none
     of this runs: the <details> keeps the chart, both units are shown at once,
     and the dialog shell stays empty and hidden forever.

     THE UNIT SWITCH IS ONE ATTRIBUTE. data-unit on the chart; the stylesheet
     renders one of the two spans in each cell. The columns are nailed by
     <colgroup> under table-layout: fixed, so switching cannot move a column
     edge by a pixel.
     ====================================================================== */
  var msBox   = doc.getElementById('pd-ms');
  var msPanel = doc.getElementById('pd-ms-panel');
  var msSlot  = doc.getElementById('pd-ms-slot');
  var msChart = doc.getElementById('pd-mschart');
  var msRow   = doc.getElementById('pd-msopen');
  var msAcc   = doc.getElementById('pd-acc-ms');
  var msLink  = doc.getElementById('pd-msopen2');
  /* PLURAL, BECAUSE THE METAFIELD IS. A two-piece publishes a Top table and a
     Skirt table; a dress sold in four cuts publishes four. Each wrapper marks
     and scrolls itself, against its OWN header row rather than against one
     list borrowed from the first table. */
  var tblwraps = Array.prototype.slice.call(doc.querySelectorAll('.pd-tblwrap'));
  var tblwrap = tblwraps[0] || null;
  var unitWords = Array.prototype.slice.call(doc.querySelectorAll('.pd-ms-unitword'));
  var msSizes = doc.getElementById('pd-mssizes');
  var msGuide = doc.getElementById('pd-msguide');
  var msTables = Array.prototype.slice.call(doc.querySelectorAll('.pd-tbl'));
  var msReturn = null, msHide = null;

  /* HER COLUMN, MARKED — and the two either side of it kept, because "am I an
     L or an XL?" is the question a size chart is opened to answer. The classes
     are what the stylesheet keys off: the standalone build could name S, M, L,
     XL and XXL in CSS, and this store sells sizes called "M(US 6)". */
  function sizesOf(tbl) {
    return Array.prototype.map.call(tbl.querySelectorAll('thead th[data-s]'), function (th) {
      return th.getAttribute('data-s');
    });
  }
  function paintChartSize() {
    var chosen = chosenSize();
    msTables.forEach(function (tbl) {
      var list = sizesOf(tbl);
      var key = keyIn(list, chosen);
      var cells = tbl.querySelectorAll('thead th[data-s], tbody td[data-s]');
      var i = list.indexOf(key);
      var lo = 0, hi = -1;
      if (i > -1 && list.length) {
        lo = Math.max(0, Math.min(i - 1, list.length - 3));
        hi = Math.min(list.length - 1, lo + 2);
      }
      Array.prototype.forEach.call(cells, function (c) {
        var s = c.getAttribute('data-s');
        var n = list.indexOf(s);
        c.classList.toggle('is-mine', key !== null && s === key);
        c.classList.toggle('is-near', hi >= lo && n >= lo && n <= hi && s !== key);
      });
      tbl.classList.toggle('is-windowed', i > -1);
    });
  }

  /* The soft right edge that says "there is more", and the tab stop that lets
     a keyboard drive the scroll — added only while the wrapper really does
     scroll, so a desktop is not given an empty stop. */
  function paintTable() {
    var anyScroll = false;
    tblwraps.forEach(function (w) {
      var over = w.scrollWidth - w.clientWidth;
      var scrollable = over > 1;
      if (scrollable) anyScroll = true;
      w.classList.toggle('is-whole', !scrollable);
      w.classList.toggle('is-end', scrollable && w.scrollLeft >= over - 1);
      w.classList.toggle('is-scrolled', scrollable && w.scrollLeft > 1);
      if (scrollable) w.setAttribute('tabindex', '0');
      else w.removeAttribute('tabindex');
    });
    if (msChart) msChart.classList.toggle('is-scroller', anyScroll);
  }

  /* Her column, brought into view, flush against the sticky label column
     rather than eight pixels short of it: a sliver of the previous column
     shows as half a number, which on a size chart is not an ugly sliver, it is
     a wrong number. Where that overshoots the end of the scroll we step back a
     whole column at a time instead of taking the browser's clamp. */
  function scrollToSize() {
    tblwraps.forEach(scrollWrapToSize);
  }
  function scrollWrapToSize(tblwrap) {
    if (!tblwrap) return;
    var tbl = tblwrap.querySelector('.pd-tbl');
    var key = tbl ? keyIn(sizesOf(tbl), chosenSize()) : null;
    if (!key) { tblwrap.scrollLeft = 0; paintTable(); return; }
    var cell = tblwrap.querySelector('thead th[data-s="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    var lab  = tblwrap.querySelector('thead th:first-child');
    if (!cell) return;
    var labW  = lab ? lab.getBoundingClientRect().width : 0;
    var maxS  = Math.max(0, tblwrap.scrollWidth - tblwrap.clientWidth);
    var wrapL = tblwrap.getBoundingClientRect().left;
    var colL  = tblwrap.scrollLeft + (cell.getBoundingClientRect().left - wrapL);
    var colW  = cell.getBoundingClientRect().width || 1;
    var want  = colL - labW;
    if (want > maxS) {
      var stepped = want - Math.ceil((want - maxS) / colW) * colW;
      want = (colL + colW - stepped <= tblwrap.clientWidth) ? stepped : maxS;
    }
    tblwrap.scrollLeft = Math.max(0, Math.min(want, maxS));
    paintTable();
  }

  var unitBtns = msChart ? Array.prototype.slice.call(msChart.querySelectorAll('.pd-unit')) : [];
  /* The choice lives here, so it survives the dialog being closed and reopened
     for as long as the page is open. Deliberately not written to storage:
     nothing else on this site remembers anything about her between visits. */
  var unit = 'cm';
  function setUnit(u) {
    unit = (u === 'in') ? 'in' : 'cm';
    if (msChart) msChart.setAttribute('data-unit', unit);
    unitBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-pd-unit') === unit ? 'true' : 'false');
    });
    unitWords.forEach(function (w) { w.textContent = (unit === 'in') ? T('inches', 'Zoll') : T('centimetres', 'Zentimetern'); });
    paintTable();
  }

  /* --- The size switcher inside the sheet ---------------------------------
     It drives the buy form's own radios rather than keeping a second copy of
     the answer: one source of truth, and choosing L in here changes the marked
     column, the stock line, the length sentence and the Add to cart button in
     the same tick, because they are all already listening to that radio. */
  var msSizeBtns = msSizes ? Array.prototype.slice.call(msSizes.querySelectorAll('.pd-mssize')) : [];
  function paintMsSizes() {
    var size = chosenSize();
    msSizeBtns.forEach(function (b) {
      var want = b.getAttribute('data-pd-size');
      b.setAttribute('aria-pressed', want === size ? 'true' : 'false');
      var inp = null;
      sizeInputs.forEach(function (i) { if (i.value === want) inp = i; });
      b.disabled = !!(inp && inp.disabled);
    });
  }
  msSizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var want = b.getAttribute('data-pd-size');
      var input = null;
      sizeInputs.forEach(function (i) { if (i.value === want) input = i; });
      if (!input || input.disabled || input.checked) return;
      input.checked = true;
      /* Dispatched, not called: everything downstream of a size is already
         bound to this event, so the switcher adds no second code path. */
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  function openMs(from) {
    if (!msBox || msBox.classList.contains('is-open')) return;
    msReturn = from || doc.activeElement;
    if (msHide) { clearTimeout(msHide); msHide = null; }
    msBox.hidden = false;
    lock(true);
    requestAnimationFrame(function () {
      msBox.classList.add('is-open');
      msPanel.focus({ preventScroll: true });
      paintTable();
      scrollToSize();
    });
  }
  function closeMs() {
    if (!msBox || !msBox.classList.contains('is-open')) return;
    msBox.classList.remove('is-open');
    lock(false);
    if (msReturn && msReturn.focus) msReturn.focus({ preventScroll: true });
    msReturn = null;
    if (msHide) clearTimeout(msHide);
    /* Must outlast the panel's own transition, which is --sr-dur-couture
       (760ms) now that the dialog opens in the same register as the
       photographs. Too short and the sheet is display:none'd mid-slide. */
    msHide = setTimeout(function () {
      if (!msBox.classList.contains('is-open')) msBox.hidden = true;
    }, reduced ? 0 : 820);
  }

  if (msBox && msSlot && msChart && msRow && msAcc) {
    msSlot.appendChild(msChart);      /* moved, never copied */
    msAcc.hidden = true;              /* the no-script row stands down */
    msRow.hidden = false;             /* the dialog row takes its place */

    msRow.addEventListener('click', function () { openMs(msRow); });
    if (msLink) {
      msLink.addEventListener('click', function (e) { e.preventDefault(); openMs(msLink); });
    }
    Array.prototype.forEach.call(msBox.querySelectorAll('[data-pd-msclose]'), function (el) {
      el.addEventListener('click', closeMs);
    });
    doc.addEventListener('keydown', function (e) {
      if (!msBox.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeMs(); return; }
      if (e.key === 'Tab') trap(e, msPanel);
    });
    unitBtns.forEach(function (b) {
      b.addEventListener('click', function () { setUnit(b.getAttribute('data-pd-unit')); });
    });
    setUnit('cm');
    /* THE WAY BACK OUT. Closes the sheet, opens the length panel, and puts the
       focus on its summary rather than on the trigger that no longer exists on
       screen — so a keyboard lands where the answer is. */
    if (msGuide) {
      msGuide.addEventListener('click', function () {
        var g = doc.getElementById('pd-guide');
        closeMs();
        if (!g) return;
        g.open = true;
        var sum = g.querySelector('summary');
        if (sum) {
          sum.focus({ preventScroll: true });
          sum.scrollIntoView({ block: 'center' });
        }
      });
    }
    sizeInputs.forEach(function (i) { i.addEventListener('change', scrollToSize); });
    addEventListener('resize', paintTable);
    tblwraps.forEach(function (w) { w.addEventListener('scroll', paintTable, { passive: true }); });
  } else if (tblwraps.length) {
    /* Shell missing for any reason: the chart is still in the accordion and
       still has to say when it scrolls. */
    tblwraps.forEach(function (w) { w.addEventListener('scroll', paintTable, { passive: true }); });
    addEventListener('resize', paintTable);
    if (msAcc) msAcc.addEventListener('toggle', paintTable);
    paintTable();
  }

  /* THE SALE COUNTDOWN (11 Oct 2026). Counts to the fixed end time printed
     in data-end (UTC, from the section setting) and removes the line once it
     is reached. It never restarts and never extends: it reads the clock, not
     the visit. Without a script the line keeps the end date in words. */
  (function () {
    var sale = doc.getElementById('pd-sale');
    var when = doc.getElementById('pd-sale-when');
    if (!sale || !when) return;
    var end = Date.parse(sale.getAttribute('data-end') || '');
    if (!end) return;
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { sale.hidden = true; return false; }
      var m = Math.floor(ms / 60000);
      var d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
      var t = d > 0 ? d + (d === 1 ? T(' day ', ' Tag ') : T(' days ', ' Tagen ')) + h + T(' h', ' Std.')
            : h > 0 ? h + T(' h ', ' Std. ') + mm + T(' min', ' Min.')
            : Math.max(mm, 1) + T(' min', ' Min.');
      when.textContent = T('Ends in ', 'endet in ') + t;
      return true;
    }
    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 30000);
    }
  })();

  /* THE LANGUAGE BUTTON (13 Oct 2026). Records the choice for this browser
     session and reloads, so every string on the page, including the ones this
     script writes, is in one language. If the session cannot be written, it
     switches what can be switched without a reload. */
  var langBtn = doc.querySelector('[data-sr-lang]');
  if (langBtn) {
    langBtn.addEventListener('click', function () {
      var toDe = !root.hasAttribute('data-sr-de');
      try {
        sessionStorage.setItem('sr_de', toDe ? '1' : '0');
        location.reload();
      } catch (e) {
        if (toDe) root.setAttribute('data-sr-de', ''); else root.removeAttribute('data-sr-de');
      }
    });
  }

  /* First paint: the colourway the store opened on, then everything that
     hangs off a variant. */
  var c0 = chosenColour();
  if (c0) filterGallery(c0);
  syncAll();
})();
